<template>
  <Content @back="back">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <div class="btn active" >比赛赛事</div>
        <div class="btn "  @click="goMajorDomo">比赛报告</div>
      </div>

    </template>
    <template v-slot:nav_right v-if="userRole === 'coach'">
      <div class="yioks_btn" @click="openSelectDialog">添加参与赛事</div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <template v-if="userRole !== 'coach'">
            <select
              v-model="selectVal.organUuid"
              class="yioks_select"
              @change="changeOrg"
            >
              <option v-if="organList.length > 1" value="">全部区体育行政部门</option>
              <option
                v-for="item in organList"
                :key="item.organUuid"
                :value="item.organUuid"
              >
                {{ item.organShortName }}
              </option>
            </select>
            <select
              v-model="selectVal.youthUuid"
              class="yioks_select"
              @change="changeCenter"
            >
              <option v-if="centerList.length !== 1" value="">
                全部培训机构
              </option>
              <option
                v-for="item in centerList"
                :key="item.uuid"
                :value="item.uuid"
              >
                {{ item.youthShortName }}
              </option>
            </select>
            <select
              v-model="selectVal.squadUuid"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option v-if="squadList.length !== 1" value="">全部球队</option>
              <option
                v-for="item in squadList"
                :key="item.uuid"
                :value="item.uuid"
              >
                {{ item.shortName }}
              </option>
            </select>
          </template>
          <template v-else>
            <select
              v-model="selectVal.squadUuid"
              class="yioks_select"
              @change="changeCoachCenter"
            >
              <option value="">
                全部球队
              </option>
              <option
                v-for="item in coachSquadSelectList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </template>
          <el-date-picker
            v-model="selectVal.year"
            style="border-radius: 0;width: 130px;"
            type="year"
            clearable
            @change="changeCoachCenter"
            value-format="yyyy"
            placeholder="选择年">
          </el-date-picker>

        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.seacherString"
            type="text"
            class="yioks_input"
            style="width: 150px"
            placeholder="请输入关键字"
            @keyup.enter="changeQuery(true)"
          />
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th youthShortName"><strong>机构名称</strong></div>
              <div class="th squadName"><strong>球队名称</strong></div>
              <div class="th matchName"><strong>赛事名称/详情</strong></div>
              <div class="th matchTime"><strong>赛事时间</strong></div>
              <div class="th vs"><strong>场次</strong></div>
              <div class="th score"><strong>名次</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbodyWrap">
                <div class="tbody">
                  <div v-for="(item, index) in matchList" :key="index" class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td youthShortName" :title="item.youthShortName">
                      <p>{{ item.youthShortName }}</p>
                    </div>
                    <div class="td squadName" :title="item.squadName">
                      <p>{{ item.squadName }}</p>
                    </div>
                    <template v-if="item.tournamentReportStatus === 'COMPLETE'">
                      <div class="td matchName" :title="item.tournamentName">
                        <p><span class="itemName" @click="goDetail(item.uuid)">{{ item.tournamentName || "--" }}</span></p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="td matchName" :title="item.tournamentName">
                        <p :title="item.tournamentName">{{ item.tournamentName || "--" }}</p>
                      </div>
                    </template>
                    <div class="td matchTime" style="display:block;text-align:center">
                      <p>{{ item.matchTime | time }}</p>
                      <p>至</p>
                      <p>{{ item.endTime | time }}</p>
                    </div>
                    <div class="td vs">
                      <p>{{ item.reportNum || "--" }}</p>
                    </div>
                    <div class="td score">
                      <p>{{item.squadResult}} </p>
                    </div>
                    <div class="td opt">
                      <p>
                        <template v-if="item.tournamentReportStatus === 'INITIATED' && userRole === 'coach'"> <!--开始创建-->
                          <span class="item" @click="editMatchReport(item.uuid,item.squadUuid)">编辑</span>
                          <span class="split">/</span>
                          <span class="item" @click="recordMatchReport(item.uuid)">删除</span>
                        </template>
                        <template v-if="item.tournamentReportStatus === 'COMPLETE'"><!--已完善-->
                          <template v-if="userRole === 'system' || userRole === 'admin' || userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club'">
                            <span class="item" @click="backMatchReport(item.uuid)">退回</span>
                            <span class="split">/</span>
                          </template>
                          <span class="item" @click="goDetail(item.uuid)">查看</span>
                          <!--<template v-if="userRole !== 'player'">-->
                            <!--<span class="item" @click="download(item.uuid)">下载</span>-->
                          <!--</template>-->
                        </template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <template v-if="userRole === 'coach'">
          <yioks-empty
            v-if="empty"
            tips="暂时没有数据，"
            name="立即添加比赛报告"
            @callback="openSelectDialog"
          ></yioks-empty>
        </template>
        <template v-else>
          <yioks-empty
            v-if="empty"
            tips="暂时没有数据">
          </yioks-empty>
        </template>
        <el-dialog
            title="请选择比赛球队"
            :visible.sync="isOpenMatchAdd"
            width="500px"
            :before-close="dialogBeforeClose"
        >
          <div class="add-wrapper">
            <el-select class="add-select" clearable="" v-model="addMatchSquadUuid" placeholder="请选择球队">
              <el-option
                  v-for="item in coachSquadSelectList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.squadDissolve">
              </el-option>
            </el-select>
          </div>
          <div slot="footer" class="add-footer">
            <el-button type="primary" @click="addMatch">确 定</el-button>
            <el-button type="danger" @click="isOpenMatchAdd = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
      <Pagination :total="total" :page.sync="page" />
      <yioks-tip
        :showTip="showTip"
        tipMsg="确定删除该比赛赛事吗?"
        @callback="isDelete"
      />
      <yioks-tip
          :showTip="showBackTip"
          tipMsg="确定退回该比赛赛事吗?"
          @callback="isBack"
      />

    </template>
  </Content>
</template>

<script>
import "vue-awesome/icons/regular/trash-alt";
import "vue-awesome/icons/regular/edit";
import match from "@/api/match";
import squad from "@/api/squad";
import person from "@/assets/images/common/person.jpg";
import storage from "@/utils/storage";
import common from "@/api/common";
import rulesMixin from "@/utils/formRules/rulesMixin";
import { filterIdNumber, getAgeFromIdNumberYear } from "@/utils/yioks_filter";
export default {
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    UploadFile: () => import("@/components/UploadFile"),
  },
  filters: {
    filterIdNumber,
    getAgeFromIdNumberYear,
  },
  mixins: [rulesMixin],
  data() {
    return {
      downIng: false,
      matchList: [],
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      person,
      organList: [],
      centerList: [],
      squadList: [],
      selectVal: {
        organUuid: "",
        year:new Date().getFullYear().toString(),
        youthUuid: "",
        squadUuid: "",
        tournamentReportStatus: "",
        seacherString: "",
      },
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      showBackTip: false, // 是否回退
      backUuid: "", // 要被退回比赛的uuid
      showTip: false, // 是否删除
      loading: true,
      allSquad: "",
      tournamentUuid: "", // 比赛uuid
      coachSquadSelectList: [], // 教练员专用搜索选项
      addMatchSquadUuid: "", // 添加比赛球队uuid
      isOpenMatchAdd: false, // 是否打开添加比赛球弹框
    };
  },
  watch: {
    page() {
      this.changeQuery();
    },
  },

  computed: {
  },

  created() {
    const { page, seacherString, squadUuid, organUuid, youthUuid,tournamentReportStatus, year } =
      this.$route.query;
    page && (this.page = Number(page));
    seacherString && this.$set(this.selectVal, "seacherString", seacherString);
    tournamentReportStatus && this.$set(this.selectVal, "tournamentReportStatus", tournamentReportStatus);
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    squadUuid && this.$set(this.selectVal, "squadUuid", squadUuid);
    year && this.$set(this.selectVal, "year", year);
    if (this.userRole === "coach") {
      this.getSearchSelectList();
    } else {
      this.getOrganListAndCenterList();
    }
    this.getMatchList();
  },
  methods: {

    goMajorDomo(){
      this.$router.push({
        path: "list",
        query: {},
      });
    },
    back(){
      this.$router.go(-1);
    },
    getMatchList() {
      this.loading = true;
      this.showList = false;
      this.empty = false;
      let request;
      if (this.userRole === "system" || this.userRole === "admin") {
        request = match.getMatchReportListSystemTournament;
      } else if (this.userRole === "organ") {
        request = match.getMatchReportListOrganTournament;
      } else if (this.userRole === "youth" || this.userRole === "trainCamp" || this.userRole === "club"
      ) {
        request = match.getMatchReportListYouthTournament;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = match.getMatchReportListCoachTournament;
      }
      let { ...rest } = this.selectVal;
      request({ page: this.page, size: this.pageSize, ...rest })
        .then((res) => {
          this.loading = false;
          this.total = res.totalElements;
          if (res.content.length) {
            this.matchList = res.content;
            this.showList = true;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },

    // 打开添加比赛球队弹框
    openSelectDialog() {
      this.isOpenMatchAdd = true
    },

    dialogBeforeClose() {
      this.addMatchSquadUuid = "";
      this.isOpenMatchAdd = false;
    },

    // 添加比赛报告
    addMatch() {
      if(this.addMatchSquadUuid) {
        const queryData = {
          squadUuid: this.addMatchSquadUuid,
        };
        this.addMatchSquadUuid = "";
        this.$router.push({
          path: "addMatchTournament",
          query: queryData,
        });
        this.isOpenMatchAdd = false;
      }

    },

    // 编辑比赛报告
    editMatchReport(uuid, squadUuid){
      const queryData = {
        uuid,
        squadUuid,
      };
      this.$router.push({
        path: "addMatchTournament",
        query: queryData,
      });
    },

    // 是否打开删除
    recordMatchReport(uuid) {
      this.showTip = true;
      this.tournamentUuid = uuid;
    },
    isDelete(isSure) {
      if (isSure) {
        match.recordMatchReportTournamentDeleted(this.tournamentUuid).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.getMatchList();
            this.showTip = false;
          }
        });
      } else {
        this.showTip = false;
      }
    },

    // 是否回退比赛
    backMatchReport(uuid) {
      this.showBackTip = true;
      this.backUuid = uuid;
    },
    isBack(isSure){
      if (isSure) {
        match.backTournamentReport(this.backUuid).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.getMatchList();
            this.showBackTip = false;
          }
        });
      }else {
        this.showBackTip = false;
      }
    },

    // 查看比赛
    goDetail(uuid) {
      this.$router.push({
        path: "detailTournament",
        query: {
          uuid,
        },
      });
    },

    // 下载比赛报告--暂未完成
    download(uuid) {
      if (this.downIng) return;
      this.downIng = true;
      match.downloadMatchReport(uuid).then(res => {
        const { fileName, filePath } = res
        const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
        common.downfile(transferPath, fileName);
        this.downIng = false
      }).catch(err => {
        this.downIng = false
      })
    },

    // 获取联动下拉列表
    getOrganListAndCenterList() {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = squad.getOrgListByCoachOrLeader;
      }
      request(data).then((res) => {
        this.organList = res;
        if (this.selectVal.organUuid) {
          if (this.selectVal.youthUuid) {
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            if (this.selectVal.squadUuid) {
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
            }
          }
        } else {
          if (this.organList.length === 1) {
            this.$set(this.selectVal, "organUuid", this.organList[0].organUuid);
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            if (this.centerList.length === 1) {
              this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
              if (this.squadList.length === 1) {
                this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
              }
            }
          }
        }
      });
    },

    // 教练员搜索选项
    getSearchSelectList() {
      const _ = require("lodash");
      squad.getSquadListCoachAll().then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const uni_selectYouthList = _.unionBy(res, "squadUuid");
          this.coachSquadSelectList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName} - ${ item.shortName }`,
            value: item.squadUuid,
            key: JSON.stringify({ squadUuid: item.squadUuid, youthUuid: item.youthUuid, organUuid: item.organUuid }),
            squadDissolve:item.squadDissolve,
          }));
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    changeOrg() {
      this.centerList = [];
      this.squadList = [];
      this.$set(this.selectVal, "youthUuid", "");
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.organUuid) {
        const { youthList } = this.organList.find((item) => {
          return item.organUuid === this.selectVal.organUuid;
        });
        this.centerList = youthList || [];
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
          this.squadList =
            this.centerList.find((item) => {
              return item.uuid === this.selectVal.youthUuid;
            }).squadList || [];
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
          }
        }
      }
      this.changeQuery(true);
    },
    changeCenter() {
      this.squadList = [];
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.youthUuid) {
        this.squadList =
          this.centerList.find((item) => {
            return item.uuid === this.selectVal.youthUuid;
          }).squadList || [];
        if (this.squadList.length === 1) {
          this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
        }
      }
      this.changeQuery(true);
    },
    changeCoachCenter() {
      this.changeQuery(true);
    },
    changeQuery(flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          seacherString: this.selectVal.seacherString,
          tournamentReportStatus: this.selectVal.tournamentReportStatus,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          squadUuid: this.selectVal.squadUuid,
          year: this.selectVal.year,
        },
      });
      this.getMatchList();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
    /* flex 1 */
    /* overflow hidden */
    .tbodyWrap
      display block
    // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 60px
        display flex
        border-bottom 1px solid $color_white
      .itemName
        cursor pointer
        user-select none
        color $green_color
    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
    .seq
      width 7%
    .youthShortName
      width 16%
    .squadName
      width 18%
    .matchName
      width 22%
    .matchTime
      width 13%
    .vs
      width 7%
    .score
      width 7%
    .opt
      width 10%
      p
        width 100%
        text-align center
        .item
          cursor pointer
          user-select none
          color $green_color
        .split
          margin 0 5px
.demo-ruleForm
  height 475px
.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word
.yioks_select
  width 130px !important

.add-wrapper
  display flex
  padding 0 30px
  .add-select
    width 100%
.add-footer
  width 40%
  margin 0 auto
  display flex
  justify-content space-around
</style>
